import React, { Fragment, useState, useEffect } from 'react';
import { FormattedDate } from 'react-intl';
import { Row, Col } from 'reactstrap';
import { CustomFormInput, parseDate } from '../../../../utils';
import CustomEventAccounts from './Accounts';

const trimAll = text => text.replace(/"\s+|\s+"/g, '"');

const CustomEvent = ({ info }) => {
  const [customEvent, setCustomEvent] = useState(false);

  useEffect(() => {
    if (info) {
      if (info.mainInfo && info.accountsInfo) {
        setCustomEvent({
          ...JSON.parse(trimAll(info.mainInfo)),
          accounts: JSON.parse(trimAll(info.accountsInfo))
        })
      } 

    }
  }, [info]);

  if (!customEvent) {
    return null;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Ticker">
            {customEvent.assetticker}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Cuttoff">
            <FormattedDate value={parseDate(customEvent.CutOffDate)} />
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Position date">
            <FormattedDate value={parseDate(customEvent.PositionDate)} />
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">
            {customEvent.status}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Name">
            {customEvent.name}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={4}>
          <CustomFormInput label="Text">
            {customEvent.text}
          </CustomFormInput>
        </Col>
      </Row>
      <CustomEventAccounts accounts={customEvent.accounts} />
    </Fragment>
  );
};

export default CustomEvent;
